import { useCallback, useMemo } from "react";
import { useParticipantTracks } from "@livekit/components-react";
import { Track } from "livekit-client";
import type { Peer } from "@/react/types/Live/Peer";
import { ACTION_TYPES, sendSignal } from "./helpers";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitPeerMediaStatus = (peer: Peer) => {
  const localParticipant = useLivekitLocalParticipant();
  const trackRefs = useParticipantTracks(
    [Track.Source.Camera, Track.Source.Microphone],
    peer?.id,
  );
  const cameraRefs = useMemo(
    () => trackRefs.filter(r => r.source === Track.Source.Camera),
    [trackRefs],
  );
  const microphoneRefs = useMemo(
    () => trackRefs.filter(r => r.source === Track.Source.Microphone),
    [trackRefs],
  );

  const isMicrophoneEnabled = microphoneRefs.some(r => !r.publication.isMuted);
  const isCameraEnabled = cameraRefs.some(r => !r.publication.isMuted);

  const muteMicrophone = useCallback(
    () => sendSignal(ACTION_TYPES.MUTE_MICROPHONE, localParticipant, peer.id),
    [localParticipant, peer],
  );
  const disableCamera = useCallback(
    () => sendSignal(ACTION_TYPES.DISABLE_CAMERA, localParticipant, peer.id),
    [localParticipant, peer],
  );

  return {
    isMicrophoneEnabled,
    muteMicrophone,
    isCameraEnabled,
    disableCamera,
  };
};
